import React from 'react';
import styled from 'styled-components';
import { Trans, useTranslation } from 'react-i18next';
import { round } from 'lodash';
import numeral from 'numeral';
import { GlobalToken } from 'antd';

import Super from '@/comp/Super';
import { useMeasurement } from '@/hooks/useMeasurement';

const VolumeTooltip = ({ value, token }: { value; token: GlobalToken }) => {
  const { t } = useTranslation();
  const { tunit } = useMeasurement();

  const format = value => numeral(round(value)).format('0,0');

  return (
    <TooltipContainer theme={{ token }}>
      <table>
        <tr>
          <td>
            <div className="name">{t('Volume')}</div>
          </td>
          <td>
            <div className="value-container">
              <span className="value">{format(value)}</span>
              <span className="label">
                <Trans i18nKey={tunit('m^3')}>
                  <Super />
                </Trans>
              </span>
            </div>
          </td>
        </tr>
      </table>
    </TooltipContainer>
  );
};

const TooltipContainer = styled.div<{ theme: { token: GlobalToken } }>`
  position: relative;
  padding: ${({ theme: { token } }) => token.paddingMD}px ${({ theme: { token } }) => token.paddingLG}px;
  background-color: ${({ theme: { token } }) => token.colorBgElevated};
  color: ${({ theme: { token } }) => token.colorText};
  border-radius: 4px;
  box-shadow: ${({ theme: { token } }) => token.boxShadowSecondary};

  .title {
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    padding-bottom: ${({ theme: { token } }) => token.paddingXXS}px;
  }

  table {
    tr {
      padding: ${({ theme: { token } }) => token.paddingXXS}px;
      td {  
        position: relative;
        padding: ${({ theme: { token } }) => token.paddingXXS}px ${({ theme: { token } }) => token.paddingXS}px ${({
  theme: { token },
}) => token.paddingXXS}px 0;

        .name {
          font-size: ${({ theme: { token } }) => token.fontSize}px;
          font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
        }

        .value-container {
          font-size: ${({ theme: { token } }) => token.fontSize}px;
          .label {
            padding-left: ${({ theme: { token } }) => token.paddingXXS}px;
          }
        }
      }
    }
`;

export default VolumeTooltip;
